
export const socialConfig = {
  whatsapp: {
    text: "L'Aisne c'est mieux que tu le penses ! 🌾\nOn te prouve qu'on sait aussi bien manger, boire et s'amuser. Promis !\n👉 https://onarrivebientot.nlocale.fr",
    tooltip: "Pour les groupes de famille",
    className: "bg-green-500 hover:bg-green-600",
  },
  facebook: {
    text: "L'Aisne c'est mieux que tu le penses ! 🌾\nCe n'est pas que des champs et des vaches. On vous prouve qu'on sait aussi bien manger, boire et s'amuser. Promis !\n👉 https://onarrivebientot.nlocale.fr",
    tooltip: "Pour les groupes locaux",
    className: "bg-blue-600 hover:bg-blue-700",
  },
  twitter: {
    text: "L'Aisne c'est mieux que tu le penses ! 🌾\nCe n'est pas que des champs et des vaches. On vous prouve qu'on sait aussi bien manger, boire et s'amuser.\n👉 https://onarrivebientot.nlocale.fr #AisneSecret",
    tooltip: "Pour les twittos de Château-Thierry",
    className: "bg-black hover:bg-gray-900",
  },
  linkedin: {
    text: "L'Aisne c'est mieux que tu le penses ! 🎯\nCe n'est pas que des champs et des vaches. On vous prouve qu'on sait aussi bien manger, boire et s'amuser. Promis !\n👉 https://onarrivebientot.nlocale.fr #TourismeLocal #HautsDeFrance",
    tooltip: "Pour les pros du business",
    className: "bg-blue-600 hover:bg-blue-700",
  },
};
